import Footer from "../Components/Footer";
import Header from "../Components/Header";
import SpecialQuotes from "../Components/SpecialQuotes";
import ThoughtSection from "../Components/ThoughtSection";

export default function Message() {
  return (
    <div>
      <Header />
      <main id="main" className="main min-height bg-bgWarm">
        {/* Sandesh Section */}
        <section className="px-3 pb-10">
          <div className="w-full border-b border-heads/20 mb-5 pt-6">
            <div className="mx-auto px-8">
              <div className="mb-6 text-3xl font-bold text-heads font-Philosopher">
                <span>Sandesh</span>
              </div>
            </div>
          </div>
          
          <div className="animate-fade-in-up">
            <div className="flex relative justify-center items-center w-full z-10 mb-3">
              <img
                className="outline-offset-4 outline-dotted outline-accent rounded-lg shadow-lg"
                src={require("../assets/jkp sandesh.jpg")}
                alt=""
              />
            </div>
          </div>
          
          <div className="flex justify-center items-center gap-4 my-10 animate-fade-in-up">
            <div className="h-[2px] w-16 bg-mainDark/50 rounded"></div>
            <span className="text-accent text-2xl">🕉️</span>
            <div className="h-[2px] w-16 bg-mainDark/50 rounded"></div>
          </div>
          
          <div className="flex-1 bg-message bg-center bg-no-repeat bg-cover rounded-xl shadow-2xl overflow-hidden animate-fade-in-up mt-8">
            <div className="py-10 px-5 md:px-40 text-heads">
              <h2 className="leading-normal text-main text-4xl text-center font-bold  mb-6">
                विजयते श्रीकृष्ण-संकीर्तनम
              </h2>
              <p className="py-5 text-xl font-medium text-main">प्रिय साधको,</p>
              <p className="text-lg leading-relaxed mb-4">
                कलिकाल में नाम धन ही सबसे बड़ा धन (साधना) है। कलिकाल में यही एक
                मात्र कल्याण का मार्ग शास्त्रों-वेदो में बताया गया है।
              </p>
              
              <div className="bg-white/10 rounded-lg p-4 my-6 border border-white/20">
                <SpecialQuotes
                  nosvg
                  data={{
                    stanza1: "हरेर्नाम हरेर्नाम हरेर्नामैव केवलं।",
                    stanza2: "कलौ नास्त्यैव नास्त्यैव नास्त्यैव गतिरन्यथा।।",
                    writer: "- बृहन्नार्दीय पुराण",
                  }}
                />
              </div>
              
              <p className="text-lg leading-relaxed mb-4">
                कलियुग में केवल हरिनाम, हरिनाम और हरिनाम से ही उद्धार हो सकता
                है| हरिनाम के अलावा कलियुग में उद्धार का अन्य कोई भी उपाय नहीं
                है! नहीं है! नहीं है!
              </p>
              
              <div className="bg-white/10 rounded-lg p-4 my-6 border border-white/20">
                <SpecialQuotes
                  nosvg
                  data={{
                    stanza1: "कलयुग केवल नाम अधारा, सुमिर सुमिर नर उतरहि पारा।",
                    writer: "- रामायण",
                  }}
                />
              </div>
              
              <p className="py-3 text-lg leading-relaxed">
                इसलिए आप सभी से विनम्र प्रार्थना है की दिन में केबल 1 घंटे का
                समय प्रत्येक व्यक्ति नाम धन कमाने में लगायें। इसमें में आपके सदा
                साथ हूँ।
              </p>
              <p className="py-3 text-lg leading-relaxed">
                कृपया आप दिन में 1 घंटे का समय देने का कष्ट करें तो मेरे ऊपर
                आपकी बड़ी कृपा होगी और में आपकी इस कृपा का सदा आभारी रहूँगा।{" "}
              </p>
              
              <div className="bg-white/10 rounded-lg p-4 my-6 border border-white/20">
                <SpecialQuotes
                  nosvg
                  data={{
                    stanza1: "ब्रह्म-राम में नाम बड़, बरदायक बरदानी।",
                    stanza2: "रामचरित सत कोटि मह, लिये महेश जीय जानी ।।",
                  }}
                />
              </div>

              <div className="mt-8 text-end">
                <p className="text-2xl font-bold text-main drop-shadow-md">नाम धन भिखारी</p>
                <p className="text-xl font-bold text-mainDark drop-shadow-sm">- पं. महेश दास</p>
              </div>
            </div>
          </div>
        </section>

        {/* 5 Divine Thoughts Section */}
        <section className="px-3 pb-16 bg-white pt-10 border-t border-heads/10">
          <div className="w-full mb-8">
            <div className="mx-auto px-8 text-center">
              <h2 className="mb-2 text-4xl font-bold text-heads font-Philosopher">
                5 Divine Thoughts
              </h2>
              <div className="w-24 h-1 bg-accent mx-auto rounded"></div>
            </div>
          </div>
          
          <div className="relative mx-3 glassmorphism rounded-3xl p-8 md:p-12 shadow-2xl border-b-4 border-accent animate-fade-in-up overflow-hidden">
            {/* Background glowing blob */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-main/10 rounded-full blur-3xl"></div>
            
            <h1 className="text-3xl md:text-5xl text-center font-bold text-heads mb-4 relative z-10 font-Philosopher">
              मनुष्य जीवन में ५ बातें जरुरी हैं।
            </h1>
            <p className="text-center text-xl font-medium text-heads/60 mb-10 relative z-10">
              (5 things are necessary in human life.)
            </p>
            
            <div className="flex flex-wrap justify-center items-center gap-4 relative z-10">
              {['१. नियम (Rules)', '२. कृपा (Grace)', '३. तत्त्व ज्ञान (Philosophy)', '४. सेवा (Service)', '५. तीर्थ (Pilgrimage)'].map((item, index) => (
                <div key={index} className="px-6 py-3 bg-white shadow-md rounded-full text-accent font-bold text-lg border border-accent/20 hover:bg-accent hover:text-white transition-colors duration-300 cursor-default">
                  {item}
                </div>
              ))}
            </div>
          </div>
          
          <div className="italic mx-0 md:mx-3 rounded-lg p-3 md:p-10 space-y-12 mt-8">
            <ThoughtSection
              subheading="१. नियम (Rules)"
              paraHtml={`1. हमारे गुरुदेव जगद्गुरु श्री कृपालु जी महाराज है। <br />
            2. सच्चिदानंद श्रीकृष्ण ही हमारे एकमात्र ईश्वर है। <br />
            3. हमारा जप मंत्र "राधे" नाम है।
            <br />
            4. हमारा संकीर्तन मंत्र- "कृष्ण" नाम महामंत्र है। <br />
            5. हमारे ग्रंथ गीता-रामायण है।
            <br />`}
              img={require("../assets/ramayan.jpg")}
              img2={require("../assets/geeta.jpg")}
            />
            
            <ThoughtSection
              subheading="२. कृपा (Graces)"
              paraHtml={`<p className="my-3 font-semibold text-lg text-heads">कल्याण के लिए ५ कृपा जरुरी हैं।</p>
            १. मानव जन्म <br />
            २. सदगुरु का मिलना <br />
            ३. साधना भक्ति द्वारा शरणागति <br />
            ४. कृपा द्वारा भगवद दर्शन <br />
            ५. प्रेम और सेवा (सिद्धा भक्ति) का प्राप्त होना <br />`}
              position="start"
              img2={require("../assets/dada guru.jpg")}
              img={require("../assets/kripalu ji.jpg")}
            />
            
            <ThoughtSection
              subheading="३.तत्त्व ज्ञान (Philosophy)"
              paraHtml={`<p className="my-3 font-semibold text-lg text-heads">
            सदगुरु से ५ तत्त्वों का तत्त्व ज्ञान जरुरी है जिसे शास्त्रों
            में अर्थपंचक सिद्धांत के नाम से जाना जाता है।
          </p>
          १. माया क्या है <br />
          २. ज्ञान क्या है <br />
          ३. वैराग्य क्या है <br />
          ४. ईश्वर जीव में क्या भेद है <br />
          ५. भक्ति क्या है
          <br />`}
              img2={require("../assets/bhagwat.jpg")}
              img={require("../assets/kripalu ji lecture.jpg")}
            />
            
            <ThoughtSection
              subheading="४. सेवा (Service)"
              paraHtml={`<p className="my-3 font-semibold text-lg text-heads">
              अगर हो सके तो जीवन में ५ सेवा जरूर करनी चाहियें ।
            </p>
            १. माता पिता और गुरु की सेवा <br />
            २. पौधे लगाकर भूमि की सेवा <br />
            ३. गऊ सेवा <br />
            ४. कन्या सेवा (शिक्षा और शादी सहयोग द्वारा )<br />
            ५. साधु -संत और ब्रह्मणो की सेवा
            <br />`}
              position="start"
              img={require("../assets/beti bachao.jpg")}
              img2={require("../assets/gau seva.jpg")}
            />
            
            <ThoughtSection
              subheading="५. तीर्थ (Pilgrimage)"
              paraHtml={`<p className="my-3 font-semibold text-lg text-heads">
              अगर हो सके तो जीवन में ५ तीर्थ जरूर करने चाहियें ।
            </p>
            १. गुरु धाम <br />
            २. ब्रज धाम <br />
            ३. अयोध्या धाम <br />
            ४. काशी धाम <br />
            ५. हरिद्वार गंगा धाम <br />`}
              img2={require("../assets/maheshdas_ganga.jpg")}
              img={require("../assets/vrindavan.jpg")}
            />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
